module.exports = __webpack_public_path__ + "static/media/Floorplay_Low_Impact_Dance_Fitness.20b8285f.webp";